import { Directive } from '@angular/core';

@Directive({
  selector: '[appPageContent]',
})
export class PageContentDirective {
  constructor() {}
}
